module.exports = __webpack_public_path__ + "img/logosimbolo.f15f5e1b.png";